import { useState, useMemo } from "react";

// Utility to access nested properties safely
const getValueByPath = (obj, path) => {
  return path.split(".").reduce((acc, part) => acc?.[part], obj);
};

const useSortableData = (
  items,
  initialSortField = "",
  initialSortDirection = "asc"
) => {
  const [sortField, setSortField] = useState(initialSortField);
  const [sortDirection, setSortDirection] = useState(initialSortDirection);

  const isPureNumber = (val) =>
    typeof val === "number" ||
    (typeof val === "string" &&
      val.trim() !== "" &&
      !isNaN(val) &&
      !isNaN(parseFloat(val)));

  const isDate = (val) => typeof val === "string" && !isNaN(Date.parse(val));

  const sortedItems = useMemo(() => {
    if (!sortField) return items;

    return [...items].sort((a, b) => {
      const valueA = getValueByPath(a, sortField) ?? "";
      const valueB = getValueByPath(b, sortField) ?? "";

      // console.log(`Sorting by: ${sortField}`);
      //  console.log("Comparing:", valueA, "vs", valueB);

      if (isPureNumber(valueA) && isPureNumber(valueB)) {
        //  console.log("Using number sort");
        return sortDirection === "asc"
          ? parseFloat(valueA) - parseFloat(valueB)
          : parseFloat(valueB) - parseFloat(valueA);
      } else if (isDate(valueA) && isDate(valueB)) {
        //  console.log("Using date sort");
        return sortDirection === "asc"
          ? new Date(valueA) - new Date(valueB)
          : new Date(valueB) - new Date(valueA);
      } else {
        //  console.log("Using string sort");
        return sortDirection === "asc"
          ? valueA.toString().localeCompare(valueB.toString())
          : valueB.toString().localeCompare(valueA.toString());
      }
    });
  }, [items, sortField, sortDirection]);

  const handleSort = (field) => {
    setSortDirection((prevDirection) =>
      sortField === field ? (prevDirection === "asc" ? "desc" : "asc") : "asc"
    );
    setSortField(field);
  };

  return { sortedItems, sortField, sortDirection, handleSort };
};

export default useSortableData;
